exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".option-right {\n  padding-right: 16px;\n  margin-top: 22px;\n  margin-bottom: 2px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/log/audit-log.component.css
// module id = 815
// module chunks = 0